import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { PUITranslatePipe } from '../pipes/p-ui-translate.pipe';

@Component({
    selector: 'platform-search',
    standalone: true,
    imports: [FormsModule, InputTextModule, PUITranslatePipe],
    template: `
        <div class="p-input-icon-left" [class.rounded-corners]="enableRoundedCorners">
            <i class="pi pi-search"></i>
            <input
                type="text"
                pInputText
                [placeholder]="placeholder | pTranslate"
                class="w-22rem custom-input"
                [(ngModel)]="searchQuery"
                (ngModelChange)="onSearchChange($event)"
                [class.p-inputtext-sm]="size === 'small'"
                [class.p-inputtext-lg]="size === 'large'"
            />
        </div>
    `,
    styles: [
        `
            :host {
                display: block;
            }
            .rounded-corners input {
                border-radius: 20px;
            }
            .p-input-icon-left {
                width: 100%;
            }
            .p-input-icon-left input {
                padding-left: 2.5rem;
            }
            .custom-input {
                padding: 0.6rem;
            }
        `,
    ],
})
export class SearchComponent {
    @Input() searchQuery = '';
    @Input() placeholder = 'default-cm-search';
    @Input() size: 'small' | 'medium' | 'large' = 'medium';
    @Input() enableRoundedCorners = false;

    @Output() searchChange = new EventEmitter<string>();

    private searchSubject = new Subject<string>();
    constructor() {
        this.searchSubject.pipe(debounceTime(300), distinctUntilChanged()).subscribe((searchQuery) => {
            this.searchChange.emit(searchQuery);
        });
    }

    onSearchChange(searchQuery: string) {
        this.searchSubject.next(searchQuery);
    }
}
